import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions} from '@angular/http';

import {AuthService} from './auth.service';
import {ConfigService} from './config.service';
import {LogService} from './log.service';

import * as uuid from 'uuid';


@Injectable()
export class OauthService {
	constructor(
		private http: Http,

		private authService: AuthService,
		private config: ConfigService,
		private log: LogService
	) {}


	createEmailAuthorizationUrl(payload: any) {
		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });

			let body = JSON.stringify(payload);

			this.http.post(this.config.basePath + '/v0/oauth/emailauthorizationurl', body, options)
				.toPromise()
				.then((res) => {
					let result = res.json();

					console.log('result');
					console.log(result);
					resolve(result);
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					this.log.error(err);
					reject(err);
				});
		});
	}


	createEmailAccessToken(payload: any) {
		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });

			let body = JSON.stringify(payload);

			this.http.post(this.config.basePath + '/v0/oauth/emailaccesstoken', body, options)
				.toPromise()
				.then((res) => {
					let result = res.json();

					console.log('result');
					console.log(result);
					resolve(result);
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					this.log.error(err);
					reject(err);
				});
		});
	}
}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/oauth.service.ts